import { ArrowUpOutlined } from "@ant-design/icons";
import { Space } from "antd";
import { observer } from "mobx-react-lite";
import React, { useEffect, useMemo } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { PageLayout } from "src/components/PageLayout";
import { TableSettingsType } from "../ManagementPage/Obj2Tab/ObjTableSettings/ObjTableSettingsTypes";
import { atvTokenWithBlankLink } from "./AsyncTableView/templates/atvTokenWithBlankLink";
import { DefaultTSettingsStore } from "./DefaultTSettingsStore";
import { parseFilterRestrictionFromParam } from "./filterRestriction/parseFilterRestrictionFromParam";
import styles from "./EntityFiltersPage.module.less";
import { EntityFiltersPageStore } from "./EntityFiltersPageStore";
import { EntityFiltersTable } from "./EntityFiltersTable";

export const EntityFiltersPage: React.FC = observer(() => {
  const { objectId } = useParams();
  const objectIdNum = objectId !== undefined ? objectId : undefined;
  const [searchParams] = useSearchParams();
  const filterRestrictionParam = searchParams.get("filterRestriction");

  const store = useMemo(
    () =>
      new EntityFiltersPageStore({
        tabletemplateToken: atvTokenWithBlankLink,
        defTSettingsStore: new DefaultTSettingsStore(
          TableSettingsType.entities,
        ),
      }),
    [],
  );
  useEffect(() => {
    if (!objectIdNum) return;
    store.setCurrObjId(objectIdNum);
  }, [objectIdNum, store]);

  useEffect(() => {
    store.setFilterRestrictions(
      parseFilterRestrictionFromParam(filterRestrictionParam),
    );
  }, [filterRestrictionParam, store]);

  return (
    <PageLayout pageTitle={store.currObjName} documentTitle={store.currObjName}>
      {!objectIdNum ? (
        <Space className={styles.needSelect}>
          Выберите объект для работы <ArrowUpOutlined />
        </Space>
      ) : (
        <EntityFiltersTable store={store} />
      )}
    </PageLayout>
  );
});
